<template>
  <a-card :bordered="false">
    <div>
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="12" :sm="12">
              <a-form-model-item label="选择渠道">
                <a-select
                  placeholder="请选择渠道"
                  style="width: 200px;margin-left: auto"
                  v-model="appId"
                  @change="handleChange"
                >
                  <a-select-option
                    v-for="item in wechatApp"
                    :key="item.appId"
                    :value="item.appId"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 按钮区域 -->
      <div class="table-operator">
        <a-button @click="addOrUpdate()" type="primary">新增标签</a-button>
        <a-button @click="syncTags()">标签同步</a-button>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="deleteTagBatch">
              <a-icon type="delete" />批量删除</a-menu-item
            >
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>
      <!-- 表格区域 -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
          >项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>
        <a-table
          size="middle"
          bordered
          :columns="columns"
          :data-source="tagList"
          rowKey="id"
          :scroll="{ x: 1700 }"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange
          }"
          @change="handleTableChange"
        >
          <template slot="headimgurlslot" slot-scope="text, record">
            <div class="anty-img-wrap">
              <a-avatar
                shape="square"
                :src="getHeadImageView(record.headimgurl)"
                icon="user"
              />
            </div>
          </template>
          <template slot="sexslot" slot-scope="text, record">
            <span v-if="record.sex === 1">男</span>
            <span v-if="record.sex === 2">女</span>
            <span v-if="record.sex === 0">未知</span>
          </template>
          <template slot="tagslot" slot-scope="text, record, index">
            <span>{{ getTagName(record.tagidList) }}</span>
          </template>
          <span slot="action" slot-scope="text, record">
            <a
              style="margin-left: 10px"
              @click="addOrUpdate(record.id, record.tagId, record.tagName)"
              >编辑</a
            >
            <a style="margin-left: 10px" @click="tagUser(record.tagId)"
              >分配用户</a
            >
            <a style="margin-left: 10px" @click="unTagUser(record.tagId)"
              >删除用户</a
            >
            <a
              style="margin-left: 10px"
              @click="deleteTag(record.id, record.tagId)"
              >删除</a
            >
          </span>
        </a-table>
      </div>
      <!-- 表格区域END -->

      <!-- 新增修改modal -->
      <a-modal
        :title="!dataForm.tagId ? '新增标签' : '编辑标签'"
        :visible="visible"
        @cancel="handleCancel"
        @ok="handleOk"
      >
        <a-form-model
          layout="inline"
          :model="dataForm"
          :rules="dataRule"
          ref="dataForm"
        >
          <a-form-model-item label="标签名称" prop="tagName">
            <a-input v-model="dataForm.tagName"></a-input>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <!-- 新增修改modal END -->

      <!-- 用户信息列表modal -->
      <a-modal
        title="用户信息列表"
        :visible="userVisible"
        width="1000px"
        @cancel="userHandleCancel"
        @ok="userHandleOk"
      >
        <div>
          <a-form-model
            class="ant-advanced-search-form"
            :model="searchForm"
            layout="inline"
            ref="searchForm"
            @keyup.enter.native="handleSearch"
          >
            <a-form-model-item
              label="昵称"
              placeholder="请输入昵称"
              prop="nickName"
            >
              <a-input v-model="searchForm.nickName"></a-input>
            </a-form-model-item>
            <a-form-model-item label="性别" prop="sex">
              <a-select
                style="width: 120px"
                placeholder="请选择"
                v-model="searchForm.sex"
              >
                <a-select-option value="1">男</a-select-option>
                <a-select-option value="2">女</a-select-option>
                <a-select-option value="0">未知</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="关注时间">
              <a-range-picker :value="createValue" @change="createChange" />
            </a-form-model-item>
            <a-form-item label="地区" prop="area">
              <a-cascader
                v-model="searchForm.area"
                :field-names="{ label: 'name', value: 'name', children: 'sub' }"
                :options="areaOptions"
                placeholder="请选择地区"
                change-on-select
                @change="onChange"
              ></a-cascader>
            </a-form-item>
            <a-form-model-item>
              <a-button @click="reset">重置</a-button>
              <a-button type="primary" @click="handleSearch">搜索</a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
        <a-table
          ref="table"
          size="middle"
          :rowKey="record => record.openid"
          :columns="column"
          :dataSource="userList"
          :rowSelection="{
            selectedRowKeys: userDataListSelections,
            onChange: userOnSelectChange
          }"
          class="j-table-force-nowrap"
          :pagination="userPagination"
          @change="handleUserChange"
        >
          <template slot="headimgurlslot" slot-scope="text, record, index">
            <div class="anty-img-wrap">
              <a-avatar
                shape="square"
                :src="getHeadImageView(record.headimgurl)"
                icon="user"
              />
            </div>
          </template>
          <template slot="sexslot" slot-scope="text, record, index">
            <span v-if="record.sex === 1">男</span>
            <span v-if="record.sex === 2">女</span>
            <span v-if="record.sex === 0">未知</span>
          </template>
          <template slot="tagslot" slot-scope="text, record, index">
            <span>{{ getTagName(record.tagidList) }}</span>
          </template>
        </a-table>
      </a-modal>
      <!-- 新增修改modal END -->
    </div>
  </a-card>
</template>

<script>
import channelSearch from '../weChatSearch.vue';
import {
  getAction,
  postAction,
  getFileAccessHttpUrl,
  postTag
} from '@/api/manage';
import { areaList } from '@/utils/area';
export default {
  components: {
    channelSearch
  },
  data() {
    return {
      wechatApp: [],
      appId: '',
      loading: false,
      areaOptions: areaList,
      visible: false,
      userVisible: false,
      tagList: [],
      tagListAll: [],
      userList: [],
      wechatType: '1,2,3',
      createValue: [],
      selectedRowKeys: [],
      userDataListSelections: [],

      inType: '',
      tagId: '',
      pageIndex: 1,
      pageSize: 10,
      pagination: {
        total: 0,
        pageSize: 10, //每页中显示10条数据
        showSizeChanger: false,
        pageSizeOptions: ['10', '20', '50', '100'], //每页中显示的数据
        showTotal: total => `共有 ${total} 条数据` //分页中显示总的数据
      },
      userPageIndex: 1,
      userPageSize: 4,
      userPagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      searchForm: {
        nickName: '',
        sex: '',
        startTime: '',
        endTime: ''
      },
      dataForm: {
        id: '',
        tagId: '',
        appId: '',
        tagName: ''
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: '标签ID',
          dataIndex: 'tagId',
          key: 'tagId'
        },
        {
          title: '标签名称',
          dataIndex: 'tagName',
          key: 'tagName'
        },
        {
          title: '同步时间',
          dataIndex: 'syncTime',
          customRender: function(text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text;
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 250,
          scopedSlots: { customRender: 'action' }
        }
      ],
      column: [
        {
          title: 'openId',
          dataIndex: 'openid',
          align: 'center',
          key: 'openid'
        },
        {
          title: '昵称',
          dataIndex: 'nickname',
          align: 'center',
          key: 'nickname'
        },
        {
          title: '头像',
          dataIndex: 'headimgurl',
          align: 'center',
          key: 'headimgurl',
          width: 120,
          scopedSlots: { customRender: 'headimgurlslot' }
        },
        {
          title: '性别',
          dataIndex: 'sex',
          align: 'center',
          key: 'sex',
          scopedSlots: { customRender: 'sexslot' }
        },
        {
          title: '地区',
          dataIndex: 'city',
          align: 'center',
          key: 'city'
        },
        {
          title: '标签',
          dataIndex: 'tagidList',
          align: 'center',
          key: 'tagidList',
          scopedSlots: { customRender: 'tagslot' }
        },
        {
          title: '关注时间',
          dataIndex: 'subscribeTime',
          align: 'center',
          customRender: function(text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text;
          }
        }
      ],
      dataRule: {
        tagName: [
          { required: true, message: '标签名称不能为空', trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    this.getWechatApp();
  },
  methods: {
    handleChange(value) {
      this.appId = value;
      this.getTagList();
      this.getTagListAll();
    },
    getWechatApp() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatApp/queryByType', {
        type: this.wechatType
      }).then(res => {
        if (res.success) {
          this.wechatApp = res.result;
          this.appId = res.result[0].appId;
          this.getTagList();
          this.getTagListAll();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },

    //地区选择
    onChange(checked) {
      if (checked.length == 3) {
        this.searchForm.city = checked[2];
        this.searchForm.province = checked[1];
      }
      if (checked.length == 2) {
        this.searchForm.province = checked[1];
      }
      this.searchForm.country = checked[0];
      console.log(`a-switch to ${checked}`);
    },
    getTagListAll() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/listAll', {
        appid: this.appId
      }).then(res => {
        if (res.success && res.code === 200) {
          this.tagListAll = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleTableChange(pagination) {
      this.onClearSelected();
      this.ipagination = pagination;
      this.getTagList();
    },
    handleUserChange(pagination) {
      this.userPagination = pagination;
      this.getDataList(this.tagId, this.inType);
    },
    syncTags() {
      if (!this.appId) {
        this.$message.warning('请选择渠道');
      } else {
        postAction(
          process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/syncTags',
          {
            appId: this.appId
          }
        ).then(res => {
          if (res.success && res.code === 200) {
            this.$message.success('同步任务已建立，请稍候刷新查看列表');
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    tagUser(tagId) {
      this.userVisible = true;
      this.userDataListSelections = [];
      this.inType = 'notIn';
      this.tagId = tagId;
      this.getDataList(tagId, this.inType);
    },
    unTagUser(tagId) {
      this.userVisible = true;
      this.userDataListSelections = [];
      this.inType = 'in';
      this.tagId = tagId;
      this.getDataList(tagId, this.inType);
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.searchForm = {};
      this.createValue = [];
    },
    createChange(dates, dateStrings) {
      this.createValue = dates;
      this.searchForm.beginTime = dateStrings[0];
      this.searchForm.endTime = dateStrings[1];
    },
    handleSearch(e) {
      let data = JSON.parse(JSON.stringify(this.searchForm));
      console.log(data);
      this.getDataList(this.tagId, this.inType);
    },
    addOrUpdate(id, tagId, name) {
      if (!this.appId) {
        this.$message.warning('请选择渠道');
      } else {
        if (!id) {
          this.dataForm.id = '';
          this.dataForm.tagId = '';
          this.dataForm.tagName = '';
        } else {
          this.dataForm.id = id;
          this.dataForm.tagId = tagId;
          this.dataForm.tagName = name;
        }
        this.visible = true;
      }
    },
    deleteTag(id, tagId) {
      postAction(process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/delete', {
        appId: this.appId,
        tagId: tagId,
        id: id
      }).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success('删除成功');
          this.getTagList();
        } else {
          this.$message.error(res.message, 10);
        }
      });
    },
    deleteTagBatch() {
      const ids = this.selectedRowKeys.toString();
      postAction(
        process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/deleteBatch',
        {
          appId: this.appId,
          ids: ids
        }
      ).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success('删除成功');
          this.getTagList();
        } else {
          this.$message.error(res.message, 10);
        }
      });
    },
    dataFormSubmit() {
      this.dataForm.appId = this.appId;
      let data = JSON.parse(JSON.stringify(this.dataForm));
      postTag(
        process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/save',
        data
      ).then(res => {
        if (res.success && res.code === 200) {
          if (!data.id) {
            this.$message.success('新增成功');
          } else {
            this.$message.success('更新成功');
          }
          this.visible = false;
          this.getTagList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleOk(e) {
      this.dataFormSubmit();
    },
    handleCancel(e) {
      this.$refs.dataForm.resetFields();
      this.visible = false;
    },
    userHandleOk(e) {
      postAction(
        process.env.VUE_APP_CMS_WECHAT +
          `/manage/wxUserTags/${
            this.inType == 'in' ? 'batchUnTagging' : 'batchTagging'
          }`,
        {
          appid: this.appId,
          tagId: this.tagId,
          openIds: this.userDataListSelections.join(',')
        }
      ).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success(res.message);
        } else {
          this.$message.warning(res.message);
        }
        this.userDataListSelections = [];
        this.userVisible = false;
      });
    },
    userHandleCancel(e) {
      this.$refs.searchForm.resetFields();
      this.userDataListSelections = [];
      this.userVisible = false;
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRows = selectionRows;
      this.selectedRowKeys = selectedRowKeys;
    },
    userOnSelectChange(selectedRowKeys) {
      this.userDataListSelections = selectedRowKeys;
      console.log(this.userDataListSelections);
    },
    getHeadImageView: function(headimgurl) {
      return getFileAccessHttpUrl(headimgurl);
    },
    //获取标签列表
    getTagList() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/list', {
        appid: this.appId,
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize
      }).then(res => {
        if (res.success) {
          this.tagList = res.result.records;
          this.ipagination.total = res.result.total;
        } else {
          this.tagList = [];
          this.totalCount = 0;
          this.$message.error(res.message);
        }
      });
    },
    // 获取用户数据列表
    getDataList(tagId, inType) {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wxUser/listByTagId', {
        appId: this.appId,
        tagId: tagId,
        inType: inType,
        pageNo: this.userPagination.current,
        pageSize: this.userPagination.pageSize,
        ...this.searchForm
      }).then(res => {
        if (res.success && res.code === 200) {
          this.userList =
            res.result && res.result.records ? res.result.records : [];
          this.userPagination.total = res.result.total;
        } else {
          this.userList = [];
        }
        //this.dataListLoading = false
      });
    },
    //标签名称
    getTagName(tagidList) {
      let userTag = tagidList
        .split('[')[1]
        .split(']')[0]
        .split(',');
      let userTagContent = '';
      for (let i in userTag) {
        for (let j in this.tagListAll) {
          if (userTag[i] == this.tagListAll[j].id) {
            userTagContent += this.tagListAll[j].name + ',';
          }
        }
      }
      if (userTagContent.length > 0) {
        userTagContent = userTagContent.substr(0, userTagContent.length - 1);
      }
      return userTagContent;
    }
  }
};
</script>
<style lang="less" scoped>
//@import '~@assets/less/common.less'
/** Button按钮间距 */
.ant-btn {
  margin-right: 10px;
}
.table-operator {
  margin-bottom: 10px;
}
.ant-btn-danger {
  color: #fff;
  background-color: #ff4d4f;
  border-color: #ff4d4f;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
</style>
